import * as React from 'react';
import CenteredPageContainer from 'src/components/CenteredPageContainer';
import NavBar from 'src/components/NavBar';
import styled from 'styled-components';
import { Container, Row, Col } from 'reactstrap';
import { FullWidthContainer, NoGutterRow, NoPaddingCol } from 'src/components/Grid/FullWidthGrid';
import MapView from '../../components/MapView';
import {
  PersonTextContainer,
  PersonApartmentInfoContainer,
  PersonApartmentInfoText,
  PersonNameText,
} from 'src/components/MatchComponents/PersonDetails';
import TotalPricingComponent, { Item } from '../../components/TotalPricingComponent';
import DateDropoffPickup from 'src/components/MatchComponents/DateDropoffPickup';
import * as moment from 'moment';
import { RouteComponentProps } from 'react-router';
import { MatchQuery, MatchQueryGql } from './Queries/MatchQuery';
import { PaymentErrorPage } from './ErrorPage';
import LoadingPage from './LoadingPage';
import Checkout from 'src/components/Checkout';
import { UpdateMatchMutation, UpdateMatchMutationGql } from './Mutations/UpdateMatchMutation';

// customer payment page

const ThankYouContainer = styled.div`
  background: #00144d;
  height: 156px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const ThanksForStoringWithUsText = styled.h1`
  font-style: normal;
  font-weight: normal;
  line-height: normal;
  font-size: 24px;
  text-align: center;

  color: #ffffff;
`;

const DetailText = styled.p`
  font-style: normal;
  font-weight: normal;
  line-height: 20px;
  font-size: 14px;
  text-align: center;

  color: rgba(255, 255, 255, 0.6);
`;

interface state {
  orderNumber: string;
}

const updateItems = (
  priceStandardBox: number,
  priceMediumItem: number,
  priceLargeItem: number,
  priceExtraLargeItem: number,
  priceEnormousItem: number,
  standardBoxes: number,
  mediumItems: number,
  largeItems: number,
  extraLargeItems: number,
  enormousItems: number,
) => {
  const items: Item[] = [];
  if (standardBoxes > 0) {
    items.push({
      title: 'Standard Boxes',
      price: `$${standardBoxes * priceStandardBox}`,
      dollarValue: standardBoxes * priceStandardBox,
    });
  }
  if (mediumItems > 0) {
    items.push({
      title: 'Medium Items',
      price: `$${mediumItems * priceMediumItem}`,
      dollarValue: mediumItems * priceMediumItem,
    });
  }

  if (largeItems > 0) {
    items.push({
      title: 'Large Items',
      price: `$${largeItems * priceLargeItem}`,
      dollarValue: largeItems * priceLargeItem,
    });
  }

  if (extraLargeItems > 0) {
    items.push({
      title: 'Extra Large Items',
      price: `$${extraLargeItems * priceExtraLargeItem}`,
      dollarValue: extraLargeItems * priceExtraLargeItem,
    });
  }

  if (enormousItems > 0) {
    items.push({
      title: 'Enormous Items',
      price: `$${enormousItems * priceEnormousItem}`,
      dollarValue: enormousItems * priceEnormousItem,
    });
  }

  items.push({
    title: 'Boxes & Tape',
    price: 'free',
    dollarValue: 0,
  });

  items.push({
    title: 'StoreWith Insurance',
    price: 'free',
    dollarValue: 0,
  });
  return items;
};

const CustomerPaymentPage = (props: RouteComponentProps<state>) => {
  return (
    <UpdateMatchMutation mutation={UpdateMatchMutationGql}>
      {(updateMatch, { loading, data }) => (
        <MatchQuery
          query={MatchQueryGql}
          variables={{ where: { orderNumber: props.match.params.orderNumber } }}
        >
          {({ loading, error, data }) => {
            if (loading) return <LoadingPage />;
            if (error || data == null || data.match == null) {
              return <PaymentErrorPage />;
            }

            if (data.match.studentPaid) {
              props.history.push('/post-payment');
            }

            const listingPrices = data.match.listing.price;
            const listingItems = data.match.items;
            const startDate = data.match.storageDates.startDate;
            const endDate = data.match.storageDates.endDate;

            const items: Item[] = updateItems(
              listingPrices.standardBox,
              listingPrices.mediumItem,
              listingPrices.largeItem,
              listingPrices.extraLargeItem,
              listingPrices.enormousItem,
              listingItems.standardBox,
              listingItems.mediumItem,
              listingItems.largeItem,
              listingItems.extraLargeItem,
              listingItems.enormousItem,
            );

            return (
              <CenteredPageContainer>
                <NavBar colorInverted />
                <ThankYouContainer>
                  <Container>
                    <Row>
                      <Col lg={{ size: 4, offset: 4 }} xl={{ size: 4, offset: 4 }}>
                        <ThanksForStoringWithUsText style={{ marginTop: 10 }}>
                          Thanks for storing with us!
                        </ThanksForStoringWithUsText>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={{ size: 8, offset: 2 }} xl={{ size: 6, offset: 3 }}>
                        <DetailText style={{ marginTop: 8 }}>
                          If you ended up storing a different amount of items or have any
                          questions/concerns, shoot us an email at penn@storewith.co. Otherwise, you
                          can pay below with your credit card!
                        </DetailText>
                      </Col>
                    </Row>
                  </Container>
                </ThankYouContainer>
                <FullWidthContainer fluid>
                  <NoGutterRow style={{ height: 'calc(100vh - 244px)' }}>
                    <NoPaddingCol sm={{ size: 12 }} md={{ size: 4 }}>
                      <div style={{ marginLeft: 45, marginTop: 40, marginRight: 30 }}>
                        <PersonTextContainer>
                          <PersonNameText>
                            {data.match.listing.owner.firstName} {data.match.listing.owner.lastName}
                          </PersonNameText>
                          <PersonApartmentInfoContainer style={{ marginTop: 4 }}>
                            <PersonApartmentInfoText>
                              {data.match.listing.address}
                            </PersonApartmentInfoText>
                          </PersonApartmentInfoContainer>
                        </PersonTextContainer>
                        <hr />
                        <DateDropoffPickup
                          startDate={moment(startDate)}
                          endDate={moment(endDate)}
                        />
                        <hr />
                        <TotalPricingComponent items={items} />
                        <Checkout
                          style={{ marginTop: 10, marginBottom: 10 }}
                          buttonText={'Checkout'}
                          hostName={data.match.listing.owner.firstName}
                          id={data.match.id}
                          amount={items.reduce((a, b) => a + b.dollarValue, 0) * 100}
                          onSubmit={async () => {
                            await updateMatch({
                              variables: {
                                data: { studentPaid: true },
                                where: { orderNumber: props.match.params.orderNumber },
                              },
                            });
                            props.history.push('/post-payment');
                          }}
                          invalid={false}
                        />
                      </div>
                    </NoPaddingCol>
                    <NoPaddingCol sm={{ size: 12 }} md={{ size: 8 }}>
                      <MapView
                        zoom={17}
                        center={{
                          lat: data.match.listing.location.latitude, // pull lat
                          lng: data.match.listing.location.longitude, // pull long
                        }}
                        style={{ height: '100%' }}
                      />
                    </NoPaddingCol>
                  </NoGutterRow>
                </FullWidthContainer>
              </CenteredPageContainer>
            );
          }}
        </MatchQuery>
      )}
    </UpdateMatchMutation>
  );
};

export default CustomerPaymentPage;



// WEBPACK FOOTER //
// ./src/pages/CustomerPayment/CustomerPaymentPage.tsx